import React from 'react'
import style from '../../../assets/styles/panelDeControl.module.css'

const EventoCard = ({ onClick, ...evento}) => {

    return (

        <div className={ `card ${ style.card }` } onClick={ () => onClick(evento) } >

            <img className="card-img-top" src={ evento.imagen ? evento.imagen : 'https://via.placeholder.com/300' } alt="..."/>
            <div className={ `card-body ${ style.cardBody }` } >
                <h5 className="card-title"> { evento.nombre } </h5>
                <p className={ style.cardText } > { evento.fecha } </p>
                <p className={ style.cardText } > { evento.constancia } </p>
            </div>
        </div>

    )
}

export default EventoCard
